import { StudentValidation } from 'common.components/students/typings';
import { Student } from 'common.components/typings';

import * as constants from './constants';

export const editStudentNameSuccess = (id: number, firstName: string, lastName: string, classId: number) =>
    <const>{ type: constants.EDIT_STUDENT_NAME_SUCCESS, id, firstName, lastName, classId };

export const editStudentNameError = (id: number) => <const>{ type: constants.EDIT_STUDENT_NAME_ERROR, id };

export const editStudentNameRequest = (id: number, name: string) =>
    <const>{ type: constants.EDIT_STUDENT_NAME_REQUEST, id, name };

export const getNewStudentLoginRequest = (classId: number) =>
    <const>{ type: constants.GET_NEW_STUDENT_LOGIN_REQUEST, classId };

export const getNewStudentLoginSuccess = (login: string, loginId: string) =>
    <const>{ type: constants.GET_NEW_STUDENT_LOGIN_SUCCESS, login, loginId };

export const cancelAddingNewStudent = () => <const>{ type: constants.CANCEL_ADDING_NEW_STUDENT };

export const saveNewStudentRequest = (classId: number, name: string, loginId: string) =>
    <const>{ type: constants.SAVE_NEW_STUDENT_REQUEST, classId, name, loginId };

export const saveNewStudentSuccess = (students: Array<Student>, classId: number) =>
    <const>{ type: constants.SAVE_NEW_STUDENT_SUCCESS, students, classId };

export const resetStudentLoginRequest = (classId: number, studentId: number) =>
    <const>{ type: constants.RESET_STUDENT_LOGIN_REQUEST, classId, studentId };

export const resetStudentLoginSuccess = (classId: number, studentId: number, newLogin: string) =>
    <const>{ type: constants.RESET_STUDENT_LOGIN_SUCCESS, classId, studentId, newLogin };

export const deleteStudentRequest = (classId: number, userId: number) =>
    <const>{ type: constants.DELETE_STUDENT_REQUEST, classId, userId };

export const deleteStudentSuccess = (userId: number, classId: number) =>
    <const>{ type: constants.DELETE_STUDENT_SUCCESS, userId, classId };

export const setCurrentEditingStudentName = (payload: { id: number; name: string }) =>
    <const>{ type: constants.SET_CURRENT_EDITING_STUDENT_NAME, id: payload.id, name: payload.name };

export const setCurrentEditingStudentIndex = (id: number) =>
    <const>{ type: constants.SET_CURRENT_EDITING_STUDENT_INDEX, id };

export const setSubmitting = (isSubmitting: boolean) => <const>{ type: constants.SUBMITTING, isSubmitting };

export const setRequesting = (isRequestingLogin: boolean) =>
    <const>{ type: constants.REQUESTING_LOGIN, isRequestingLogin };

export const putUsersConvertToPassportRequest = (classId: number, users: Array<{ id: number }>) =>
    <const>{ type: constants.CONVERT_STUDENTS_PASSPORT_REQUEST, users, classId };

export const putUsersConvertToPassportSuccess = () => <const>{ type: constants.CONVERT_STUDENTS_PASSPORT_SUCCESS };

export const putUsersConvertToPassportError = () => <const>{ type: constants.CONVERT_STUDENTS_PASSPORT_ERROR };

export const putUserConvertToPassportRequest = (classId: number, user: { id: number }) =>
    <const>{ type: constants.CONVERT_STUDENT_PASSPORT_REQUEST, classId, user };

export const putUserConvertToPassportSuccess = () => <const>{ type: constants.CONVERT_STUDENT_PASSPORT_SUCCESS };

export const putUserConvertToPassportError = () => <const>{ type: constants.CONVERT_STUDENT_PASSPORT_ERROR };

export const setStudentValidation = (id: number, value: StudentValidation) =>
    <const>{ type: constants.SET_STUDENT_VALIDATION, id, value };
